import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';

// Global error handler
window.addEventListener('error', (event) => {
  console.error('=== GLOBAL ERROR HANDLER ===');
  console.error('Error:', event.error);
  console.error('Message:', event.message);
  console.error('Filename:', event.filename);
  console.error('Lineno:', event.lineno);
  console.error('Colno:', event.colno);
  console.error('Stack:', event.error?.stack);
  console.error('=== END GLOBAL ERROR ===');
});

// Unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('=== UNHANDLED PROMISE REJECTION ===');
  console.error('Reason:', event.reason);
  console.error('Promise:', event.promise);
  console.error('=== END UNHANDLED REJECTION ===');
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 